import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  ChevronUp,
  Filter,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import AddPurchases from "../../core/modals/purchases/addpurchases";
import EditPurchases from "../../core/modals/purchases/editpurchases";
import ReceivePOStock from "../../core/modals/purchases/receivestock";
// import GeneratePOInvoice from '../../core/modals/purchases/generatepurchaseinvoice';
import Axios from "axios";
import {
  API_BASE_URL,
  GET_PO,
  INSERT_PURCHASE_INVOICE,
  GET_PO_RECEIVED_BY_ID,
  GET_PO_BY_ID,
  INSERT_PURCHASE_ORDEDR,
  GET_STORE,
  PO_SEND_TO_SUPPLIER,
} from "../../Config";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import ViewPurchase from "./../../core/modals/purchases/viewpurchase";
import Table from "../../core/pagination/datatable";
import NewPOInvoice from "../../core/modals/purchases/newpurchaseinvoice";
// import OrderGenerate from '../../core/modals/purchases/ordergenerate';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ViewApprovedIndents from "../../core/modals/purchases/viewapprovedindents";
import ViewConsolidatedIndents from "../../core/modals/purchases/viewconsolidatedindents";
import UploadFiles from "../UploadFiles";
import SpinLoader from "../loader/SpinLoader";
import AddPOnew from "../../core/modals/purchases/addPOnew";

const StoreWisePOList = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [editPOData, setEditPOData] = useState("");
  const [receiveStockData, setReceiveStockData] = useState("");
  const [uploadData, setUploadData] = useState("");
  // const [invoicePOData, setInvoicePOData] = useState('');
  // const [orderPOData, setOrderPOData] = useState('');
  const navigate = useNavigate();
  const [mainStoreId, setMainStoreId] = useState(0);

  // #region Session userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const supplierDataddl = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Supplier")
    );
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setSuppliersData(supplierDataddl);
    } else {
      navigate("/");
      console.log("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status) {
            const storesData = response.data.ResultData;
            const mainStore = storesData.find(
              (store) => store.IsMainStore === true
            );
            if (mainStore) {
              setMainStoreId(mainStore.Id);
              //   console.log(
              //     `Main Store ID: ${mainStore.Id}, Name: ${mainStore.Name}`
              //   );
            } else {
              console.log("No main store found");
            }
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [suppliersData, setSuppliersData] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState(purchaseData);
  const [currentDate, setCurrentDate] = useState("");
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  const [selectedSupplier, setSelectedSupplier] = useState(0);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [viewPurchaseObj, setViewPurchaseObj] = useState([]);

  const showViewModal = (purchaseObj) => {
    setViewPurchaseObj(purchaseObj);
  };

  // const showInvoiceModal = (purchaseObj) => {
  //     console.log(purchaseObj, 'obj sedning to ijvoice')
  //     setInvoicePOData(purchaseObj);
  // };

  // const showOrderModal = (purchaseObj) => {
  //     setOrderPOData(purchaseObj);
  // };

  const handleSupplierChange = (selectedOption) => {
    setSelectedSupplier(selectedOption.value);
  };

  const handleFromDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const toggleFilterVisibility = () => {
    console.log(submitBtnLoading);
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setCurrentDate(formattedDate);
  }, []);

  const fetchPOData = () => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      const api = `${API_BASE_URL}${GET_PO}?OrgId=${
        userDataSession.OrgId
      }&UserId=${
        userDataSession.UserId
      }&FromDt=${null}&ToDt=${null}&SupplierId=0`;
      Axios.get(api)
        .then((response) => {
          if (response.data.Status) {
            setPurchaseData(response.data.ResultData);
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data);
            setPurchaseData([]);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchPOData();
  }, [userDataSession]);

  useEffect(() => {
    if (selectedToDate) {
      searchWithToDate(selectedToDate);
    }
  }, [selectedToDate]);

  const handleSearchClick = () => {
    if (
      userDataSession &&
      userDataSession.OrgId &&
      (selectedFromDate || selectedToDate || selectedSupplier)
    ) {
      if (!selectedToDate) {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, "0");
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const year = today.getFullYear();
        const formattedDate = `${year}-${month}-${day}`;
        setSelectedToDate(formattedDate);
      } else {
        searchWithToDate(selectedToDate);
      }
    }
  };

  const searchWithToDate = (toDate) => {
    setLoading(true);
    const url = `${API_BASE_URL}${GET_PO}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}&FromDt=${selectedFromDate}&ToDt=${toDate}&SupplierId=${selectedSupplier}`;
    console.log(url);
    Axios.get(url)
      .then((response) => {
        if (response.data.Status) {
          setPurchaseData(response.data.ResultData);
          setLoading(false);
        } else {
          console.error("Error fetching data:", response.data);
          setPurchaseData([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setPurchaseData([]);
        setLoading(false);
      });
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleEditClick = (item) => {
    setEditPOData(item);
  };

  const handleReceiveStockClick = (item) => {
    setReceiveStockData(item);
  };

  // const handleUploadClick = (item) => {
  //     setUploadData(item);
  // };

  const handleUploadClick = (item) => {
    setUploadData({
      number: item.PurchaseId,
      type: "Purchase",
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getStatusClassName = (status) => {
    switch (status) {
      case "RECEIVED":
        return "badge bg-outline-success";
      case "PARTIALLYRECEIVED":
        return "badge bg-outline-success text-primary";
      case "ORDER":
        return "badge bg-outline-info";
      case "DRAFT":
        return "badge bg-outline-danger";
      case "PENDING":
        return "badge bg-outline-danger";
      case "SUBMITTED":
        return "badge bg-outline-primary";
      case "INVOICE":
        return "badge bg-outline-info";
      case "PENDINGAPPROVAL":
        return "badge bg-outline-secondary";
      default:
        return "";
    }
  };

  useEffect(() => {
    setFilteredData(purchaseData);
  }, [purchaseData]);

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchValue(value);
    filterData(value);
  };

  const filterData = (searchText) => {
    const lowercasedSearchText = searchText.toLowerCase();

    const filtered = purchaseData.filter((item) => {
      const transactionNo = item.AutoGentransactionNo
        ? item.AutoGentransactionNo.toString()
        : "";
      const supplierName = item.SupplierName
        ? item.SupplierName.toLowerCase()
        : "";
      const status = item.POStatus ? item.POStatus.toLowerCase() : "";

      return (
        transactionNo.includes(lowercasedSearchText) ||
        supplierName.includes(lowercasedSearchText) ||
        status.includes(lowercasedSearchText)
      );
    });
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "PO Number",
      dataIndex: "AutoGentransactionNo",
      key: "AutoGentransactionNo",
      render: (text) => `PO-${text}`,
    },
    {
      title: "PO-Date",
      dataIndex: "PODate",
      key: "PODate",
      render: (text) => (text ? formatDate(text) : "N/A"),
    },
    {
      title: "Req-Date",
      dataIndex: "RequestDate",
      key: "RequestDate",
      render: (text) => (text ? formatDate(text) : "N/A"),
    },
    { title: "Supplier Name", dataIndex: "SupplierName", key: "SupplierName" },
    {
      title: "Status",
      dataIndex: "POStatus",
      key: "POStatus",
      render: (status) => (
        <span className={getStatusClassName(status)}>{status}</span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <div>
          <Link to="#" className="dropdown-toggl" data-bs-toggle="dropdown">
            <i className="fa-solid fa-ellipsis-vertical btn border"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              to="#"
              className="dropdown-item"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightPOView"
              aria-controls="offcanvasRightPOView"
              onClick={() => showViewModal(record)}
            >
              <i className="fa-regular fa-eye me-2"></i>
              View
            </Link>
            <Link
              to="#"
              className={`dropdown-item`}
              // className={`dropdown-item ${record.POStatus === 'DRAFT' ? '' : 'disabled'}`}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightPOEdit"
              aria-controls="offcanvasRightPOEdit"
              onClick={() => handleEditClick(record)}
            >
              <i className="fa-regular fa-pen-to-square me-2"></i>
              Edit
            </Link>
            <Link
              to="#"
              className={`dropdown-item ${
                record.POStatus === "PENDINGAPPROVAL" ? "" : "disabled"
              } ${
                userDataSession.RoleId === 4 ||
                userDataSession.RoleId === 1 ||
                userDataSession.RoleId === 2
                  ? ""
                  : "disabled"
              }`}
              onClick={() => showConfirmationAlertApprove(record)}
            >
              <i className="fa-regular fa-circle-check me-2"></i>
              Approve
            </Link>
            <Link
              to="#"
              className={`dropdown-item ${
                record.POStatus === "ORDER" ? "" : "disabled"
              }`}
              onClick={() => showConfirmationAlertPOSendToSupp(record)}
            >
              <i className="fa-solid fa-cart-flatbed-suitcase me-2"></i>
              Send To Supplier
            </Link>
            <Link
              to="#"
              className={`dropdown-item ${
                record.InvoiceStatus === null &&
                ["ORDER", "RECEIVED", "PARTIALLYRECEIVED"].includes(
                  record.POStatus
                )
                  ? ""
                  : "disabled"
              }`}
              onClick={() => showConfirmationAlert(record)}
            >
              <i className="fa-regular fa-file-lines me-2"></i>
              Generate Invoice
            </Link>
            <Link
              to="#"
              className={`dropdown-item ${
                ["PARTIALLYRECEIVED", "INVOICE", "ORDER"].includes(
                  record.POStatus
                )
                  ? ""
                  : "disabled"
              }`}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightPORecSt"
              aria-controls="offcanvasRightPORecSt"
              onClick={() => handleReceiveStockClick(record)}
            >
              <i className="fa-solid fa-download me-2"></i>
              Receive Stock
            </Link>
            <Link
              to="#"
              className={`dropdown-item ${
                ["RECEIVED", "INVOICE", "ORDER", "PARTIALLYRECEIVED"].includes(
                  record.POStatus
                )
                  ? ""
                  : "disabled"
              }`}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightUploadFiles"
              aria-controls="offcanvasRightUploadFiles"
              onClick={() => handleUploadClick(record)}
            >
              <i className="fa-solid fa-cloud-arrow-up me-2"></i>
              Upload Files
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlertApprove = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Do you want to approve the order?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, approve it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        fetchViewProductsAndApprove(record);
      } else {
        MySwal.close();
      }
    });
  };

  const fetchViewProductsAndApprove = (POObj) => {
    setLoading(true);
    Axios.get(`${API_BASE_URL}${GET_PO_BY_ID}?PurchaseId=${POObj?.PurchaseId}`)
      .then((response) => {
        console.log(response.data);
        if (response.data.Status) {
          const products = response.data.ResultData;
          handleSubmitApprove(POObj, products);
        } else {
          console.error(
            "Error fetching data GET_PO_BY_ID:",
            response.data.Message
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data GET_PO_BY_ID catch:", error);
      });
    setLoading(false);
  };

  //region Handle Submit (sending the request)
  const handleSubmitApprove = (POObj, products) => {
    let totalTaxAmt = 0;
    let totalAmount = 0;
    if (products && products.length > 0) {
      totalTaxAmt = products.reduce((acc, product) => {
        const taxRate = product.CGSTRate + product.SGSTRate;
        const taxAmount =
          (product.UnitPrice * product.Quantity * taxRate) / 100;
        return acc + (taxAmount || 0);
      }, 0);

      totalAmount = products.reduce((acc, product) => {
        const amount = product.UnitPrice * product.Quantity;
        return acc + (amount || 0);
      }, 0);
    }

    const calculatedInvoiceAmount =
      totalAmount + totalTaxAmt - (products[0]?.DiscountAmount || 0);
    const PODateFormatted = POObj
      ? new Date(POObj.PODate).toISOString().split("T")[0]
      : "NULL";
    const ExpectedDateFormatted = POObj
      ? new Date(POObj.ExpectedDate).toISOString().split("T")[0]
      : "NULL";

    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      MainStoreId: mainStoreId,
      SupplierId: POObj ? POObj.SupplierId : "NULL",
      PurchaseOrder: {
        Id: POObj.PurchaseId,
        StoreId: POObj ? POObj.StoreId : "NULL",
        SupplierId: POObj ? POObj.SupplierId : "NULL",
        DiscountType: POObj ? POObj?.DiscountType : "NULL",
        DiscountAmount: POObj ? POObj?.DiscountAmount : "NULL",
        ExpectedDate: POObj?.ExpectedDate ? ExpectedDateFormatted : "NULL",
        InvoiceAmount: calculatedInvoiceAmount,
        InvoiceDate: currentDate,
        PODate: POObj?.PODate ? PODateFormatted : "NULL",
        PRStatus: "COMPLETED",
        POStatus: "ORDER",
      },
      productdetails: products.map((prod) => ({
        detailid: prod.PurchaseDetailId,
        ProductId: prod.ProductId,
        Quantity: prod.Quantity,
        UOM: prod.UOM,
        UnitPrice: prod.UnitPrice,
        CGSTRate: prod.CGSTRate,
        SGSTRate: prod.SGSTRate,
        IGSTRate: prod.IGSTRate,
        InvoicePrice: prod.InvoicePrice,
        TaxId: String(prod?.TaxId),
      })),
    };

    console.log(requestPayload, "sending data to API");

    Axios.post(`${API_BASE_URL}${INSERT_PURCHASE_ORDEDR}`, requestPayload)
      .then((response) => {
        setSubmitBtnLoading(false);
        if (response.data[0]["Success"] === 1) {
          Swal.fire({
            title: `Invoice Approved Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to Submit Request.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setSubmitBtnLoading(false);
        console.error("Error:", error);
      });
  };

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Do you want to generate the invoice?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, generate it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        fetchViewProductsAndGenerateInvoice(record);
      } else {
        MySwal.close();
      }
    });
  };

  const showConfirmationAlertPOSendToSupp = (record) => {
    MySwal.fire({
      title: "Send Purchase Order",
      text: `Are you sure you want to send the Purchase Order (PO-${
        record.AutoGentransactionNo
      }) for Supplier: ${record.SupplierName || record.SupplierId}?`,
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, send it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const requestPayload = {
          OrgId: userDataSession.OrgId,
          UserId: userDataSession.UserId,
          supplierid: record.SupplierId,
          StoreId: record.StoreId,
          RefId: record.PurchaseId,
        };

        console.log("Sending data to API...", requestPayload);

        try {
          setSubmitBtnLoading(true);

          const response = await Axios.post(
            `${API_BASE_URL}${PO_SEND_TO_SUPPLIER}`,
            requestPayload
          );

          setSubmitBtnLoading(false);

          // Handle API response
          if (response.data[0]?.Success === 1) {
            Swal.fire({
              title: `PO sent successfully!`,
              text: `The Purchase Order (PO) was sent to Supplier: ${
                record.SupplierName || record.SupplierId
              }.`,
              icon: "success",
            }).then((confirmationResult) => {
              if (
                confirmationResult.isConfirmed ||
                confirmationResult.isDismissed
              ) {
                // window.location.reload();
                fetchPOData();
              }
            });
          } else {
            Swal.fire({
              title: "Submission Error",
              text:
                response.data[0]?.Message ||
                "Failed to send the Purchase Order. Please try again later.",
              icon: "error",
            });
          }
        } catch (error) {
          setSubmitBtnLoading(false);

          console.error("Error occurred:", error);

          Swal.fire({
            title: "Service Error",
            text: "There was an error connecting to the server. Please check your connection or contact support.",
            icon: "error",
          });
        }
      } else {
        MySwal.close();
      }
    });
  };

  const fetchViewProductsAndGenerateInvoice = (POObj) => {
    // Fetch viewProducts first
    Axios.get(
      `${API_BASE_URL}${GET_PO_RECEIVED_BY_ID}?PurchaseId=${POObj.PurchaseId}&UserId=${userDataSession.UserId}`
    )
      .then((response) => {
        if (response.data.Status) {
          const products = response.data.ResultData;
          handleSubmit(POObj, products); // Pass both POObj and products to handleSubmit
        } else {
          console.error("Error fetching data:", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handleSubmit = (POObj, products) => {
    // Calculate total amount and total tax here using products
    let totalTaxAmt = 0;
    let totalAmount = 0;

    if (products && products.length > 0) {
      totalTaxAmt = products.reduce((acc, product) => {
        const taxRate = product.CGSTRate + product.SGSTRate;
        const taxAmount =
          (product.UnitPrice * product.Quantity * taxRate) / 100;
        return acc + (taxAmount || 0);
      }, 0);

      totalAmount = products.reduce((acc, product) => {
        const amount = product.UnitPrice * product.Quantity;
        return acc + (amount || 0);
      }, 0);
    }

    const calculatedInvoiceAmount =
      totalAmount + totalTaxAmt - (products[0]?.DiscountAmount || 0);

    // Construct the request payload
    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      SupplierId: POObj ? POObj.SupplierId : "NULL",
      PurchaseInvoice: {
        Id: POObj.PurchaseId,
        StoreId: POObj ? POObj.StoreId : "NULL",
        SupplierId: POObj ? POObj.SupplierId : "NULL",
        DiscountType: POObj ? POObj?.DiscountType : "NULL",
        DiscountAmount: POObj ? POObj?.DiscountAmount : "NULL",
        InvoiceAmount: calculatedInvoiceAmount, // Use the calculated amount
        InvoiceDate: currentDate,
        InvoiceStatus: "PENDING",
        POStatus: "INVOICE",
      },
      productdetails: products.map((prod) => ({
        detailid: prod.PurchaseDetailId,
        ProductId: prod.ProductId,
        Quantity: prod.Quantity,
        UOM: prod.UOM,
        UnitPrice: prod.UnitPrice,
        CGSTRate: prod.CGSTRate,
        SGSTRate: prod.SGSTRate,
        IGSTRate: prod.IGSTRate,
        InvoicePrice: prod.InvoicePrice,
        TaxId: String(prod?.TaxId),
      })),
    };

    console.log(requestPayload, "sending data to API");

    Axios.post(`${API_BASE_URL}${INSERT_PURCHASE_INVOICE}`, requestPayload)
      .then((response) => {
        setSubmitBtnLoading(false);
        if (response.data[0]["Success"] === 1) {
          Swal.fire({
            title: `Invoice Generated Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to Submit Request.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setSubmitBtnLoading(false);
        console.error("Error:", error);
      });
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setProperties({
      title: " Report",
      author: "Your Name",
      creator: "Your Application",
    });

    const tableData = [];

    const headers = ["PO Number", "Date", "Supplier Name", "Status"];
    tableData.push(headers);

    filteredData.forEach((item) => {
      const row = [];
      row.push(
        `PO${item.AutoGentransactionNo}`,
        formatDate(item.RequestDate),
        item.SupplierName,
        item.PRStatus
      );
      tableData.push(row);
    });

    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    doc.save("ProductsData.pdf");
  };

  const generateEXCEL = () => {
    if (filteredData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();

    const headers = ["PO Number", "Date", "Supplier Name", "Status"];

    const wsData = filteredData?.map((item) => ({
      "PO Number": `PO${item.AutoGentransactionNo}`,
      Date: formatDate(item.RequestDate),
      "Supplier Name": item.SupplierName,
      Status: item.PRStatus,
    }));

    wsData.unshift({
      "PO Number": headers[0],
      Date: headers[1],
      "Supplier Name": headers[2],
      Status: headers[3],
    });

    const ws = XLSX.utils.json_to_sheet(wsData, { skipHeader: true });

    XLSX.utils.book_append_sheet(wb, ws, "ProductsData");

    XLSX.writeFile(wb, "ProductsData.xlsx");
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Purchase List</h4>
                <h6>Manage your purchases</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={generateEXCEL}>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              {/* <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li> */}
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="d-flex purchase-pg-btn">
              {/* <div className="page-btn">
                                <Link
                                    to="#"
                                    className="btn btn-added"
                                    data-bs-toggle="modal"
                                    data-bs-target="#new-purchase-invoice"
                                >
                                    <PlusCircle className="me-2"/> 
                                    Genearte New Invoice
                                </Link>
                            </div> */}
              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-added"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightApprInds"
                  aria-controls="offcanvasRightApprInds"
                  // onClick={handleViewApprovedClick}
                >
                  {/* <PlusCircle className="me-2" /> */}
                  <i className="fa-regular fa-eye me-2"></i>
                  View Indents
                </Link>
              </div>
              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-added"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                >
                  <i className="fa-regular fa-eye me-2"></i>
                  Consolidated Indents
                </Link>
              </div>
              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-added"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasPOAdd"
                  aria-controls="offcanvasPOAdd"
                >
                  <PlusCircle />
                  {/* Add Purchase */}
                </Link>
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchValue}
                      onChange={handleSearchChange}
                      className="form-control form-control-sm formsearch"
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
              </div>
              {/* /Filter */}
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row mb-2">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <label>Supplier</label>
                      {/* <div className="input-blocs"> */}
                      <Select
                        className="select"
                        id="categorySelect"
                        onChange={handleSupplierChange}
                        options={[
                          { value: 0, label: "All" }, // "All" option with value 0
                          ...(suppliersData
                            ? suppliersData.map((store) => ({
                                value: store.ItemId,
                                label: store.ItemValue,
                              }))
                            : []),
                        ]}
                        placeholder="Choose supplier"
                      />
                      {/* </div> */}
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <label>From Date</label>
                      <div className="input-blocs">
                        <input
                          type="date"
                          className="form-control"
                          onChange={handleFromDateChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <label>To Date</label>
                      <div className="input-bloks">
                        <input
                          type="date"
                          className="form-control"
                          onChange={handleToDateChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-6">
                      <label className="text-white">Search</label>
                      <div className="input-bloks">
                        <input
                          type="button"
                          className="btn btn-primary"
                          value="Search"
                          onClick={handleSearchClick}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}

              <div className="table-responsive">
                {loading ? (
                  // <div className="loader m-auto"></div>
                  <SpinLoader />
                ) : (
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    rowKey="PurchaseId"
                    pagination={{ pageSize: 10 }}
                  />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>

      <ViewPurchase POObj={viewPurchaseObj} />
      <EditPurchases POObj={editPOData} />
      <AddPurchases />
      <AddPOnew/>
      <ViewApprovedIndents />
      <ViewConsolidatedIndents />
      <ReceivePOStock POObj={receiveStockData} />
      <NewPOInvoice />
      <UploadFiles number={uploadData?.number} type={uploadData?.type} />

      {/* <GeneratePOInvoice POObj={invoicePOData} /> */}
      {/* <OrderGenerate POObj={orderPOData}/> */}
    </div>
  );
};

export default StoreWisePOList;
